import { callExternalApi } from "../../../services/external-api.service";
import { FeedbackType } from "../../../../types/database";

interface CreateFeedbackData {
    title: string;
    content: string;
    type?: FeedbackType;
    is_anonymous?: boolean;
    priority?: number; // 1-5
    tags?: string[];
}

interface UpdateFeedbackData {
    title?: string;
    content?: string;
    type?: FeedbackType;
    is_anonymous?: boolean;
    priority?: number; // 1-5
    tags?: string[];
    internal_notes?: string;
}

class AdvisorFeedbackHttpClient {
    _apiServerUrl;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    async createFeedback(projectTag: string, feedbackData: CreateFeedbackData, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/feedback`,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            data: feedbackData,
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async submitFeedback(projectTag: string, feedbackId: number, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/feedback/${feedbackId}/submit`,
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async getAdvisorFeedback(projectTag: string, advisorId: number, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/${advisorId}/feedback`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async updateFeedback(projectTag: string, feedbackId: number, feedbackData: UpdateFeedbackData, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/feedback/${feedbackId}`,
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            data: feedbackData,
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }

    async deleteFeedback(projectTag: string, feedbackId: number, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/advisor/feedback/${feedbackId}`,
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data?.data || null,
            error,
        };
    }
}

export default AdvisorFeedbackHttpClient; 